export class GeoService {
  /**
   * Obtiene la ubicación actual del dispositivo.
   * Retorna { lat, lng } o lanza error si no se puede.
   */
  static async getCurrentLocation(options = {}) {
    if (!navigator.geolocation) {
      throw new Error("Geolocalización no soportada por este navegador.");
    }

    const defaultOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 60000
    };

    const finalOptions = { ...defaultOptions, ...options };

    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, finalOptions);
    });

    return {
      lat: position.coords.latitude,
      lng: position.coords.longitude
    };
  }

  /**
   * Obtiene ubicación pero si falla devuelve fallback (no rompe flujo)
   */
  static async getCurrentLocationOrDefault(defaultValue = { lat: 0, lng: 0 }, options = {}) {
    try {
      return await this.getCurrentLocation(options);
    } catch {
      return defaultValue;
    }
  }
}
